import * as MODULES from '../module-codes'
import axios from 'axios'
import Vue from 'vue'

export const state = () => ({
    documents: [],
    userDocuments: {},
    watchedDocuments: [],
})

export const getters = {
}

export const actions = {
    populateFromDB: async ({ commit, dispatch }, payload) => {
        dispatch('populateSettingsFromDB')
        if (payload) {
            commit('SET_INDIVIDUAL_EDITOR_USER_CONTENT', payload)
        }
    },
    populateSettingsFromDB: async ({ commit }) => {
        axios.post('/api/pcs/individualEditor', {
            params: {
                pcs: localStorage.getItem('pcs')
            }
        }).then(res => {
            commit("SET_INDIVIDUAL_EDITOR_DATA", res.data['settings'])
        })
    },
    updateStateInDB: async ({ state, rootState }) => {
        await axios.post('/api/updateModule', {
            params: {
                moduleState: {
                    userDocuments: state.userDocuments,
                    watchedDocuments: state.watchedDocuments
                },
                moduleName: MODULES.INDIVIDUAL_EDITOR,
                pcs: localStorage.getItem('pcs'),
                classId: rootState.auth.classId,
            }
        })
    },
    submitDocument: async ({ state, commit, dispatch }, payload) => {
        commit('SUBMIT_INDIVIDUAL_EDITOR_DOCUMENT', payload)
        
        let watchedDocument = state.watchedDocuments.find((doc) => doc.documentName === payload.docName)
        if (watchedDocument) {
            dispatch("events/processEvent", { eventId: watchedDocument.event_id }, { root: true });
            commit('REMOVE_WATCHED_DOCUMENT', watchedDocument)
        }

        await dispatch('updateStateInDB')
    },
    addWatchedDocument: async ({ commit, dispatch }, payload) => {
        commit('ADD_WATCHED_DOCUMENT', payload)
        await dispatch('updateStateInDB')
    },
}

export const mutations = {
    SET_INDIVIDUAL_EDITOR_USER_CONTENT(state, payload) {
        state.userDocuments = payload.userDocuments
        state.watchedDocuments = payload.watchedDocuments
    },
    SET_INDIVIDUAL_EDITOR_DATA(state, payload) {
        state.documents = payload.documents
    },
    SUBMIT_INDIVIDUAL_EDITOR_DOCUMENT(state, payload) {
        let docName = payload.docName
        if (!state.userDocuments[docName]) {
            Vue.set(state.userDocuments, docName, {
            html: payload.documentHtml,
            name: docName,
            submittedAt: null,
            })
        }
        Vue.set(
            state.userDocuments[docName],
            'submittedAt',
            new Date().toLocaleString()
        )
    },
    ADD_WATCHED_DOCUMENT(state, payload) {
        state.watchedDocuments.push(payload)
    },
    REMOVE_WATCHED_DOCUMENT(state, payload) {
        state.watchedDocuments = state.watchedDocuments.filter((doc) => doc.documentName !== payload)
    }
}